import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Bus, CheckCircle2, Loader2 } from "lucide-react";
// PROMPT 96 (2026-09-11): "me olvidé la contraseña". Se pide el correo y llega un link.
// La pantalla muestra SIEMPRE el mismo mensaje, exista o no la cuenta: si dijera "ese
// correo no existe", cualquiera podría ir probando direcciones para saber quién tiene
// cuenta acá.
export default function RecuperarPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [listo, setListo] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const enviar = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/recuperar", { email: email.trim().toLowerCase() });
      setMensaje(data?.mensaje || "");
      setListo(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "No pudimos procesar el pedido.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-10">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-slate-900 text-white">
            <Bus className="h-5 w-5" />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-bold text-slate-900">Tours NY</div>
            <div className="text-xs text-slate-500 tracking-wide">· Reservas</div>
          </div>
        </div>
        {listo ? (
          <div data-testid="recuperar-listo">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 mb-4">
              <CheckCircle2 className="h-5 w-5" />
            </div>
            <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Revisá tu correo</h1>
            <p className="text-sm text-slate-500 mt-2">{mensaje}</p>
            <p className="text-xs text-slate-400 mt-4">El link sirve una sola vez y vence en una hora.</p>
            <Link to="/login" className="inline-block mt-8 text-sm text-slate-700 underline" data-testid="recuperar-volver">
              Volver al ingreso
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">
              Recuperar la contraseña
            </h1>
            <p className="text-sm text-slate-500 mt-2 mb-8">
              Poné tu correo y te mandamos un link para elegir una nueva.
            </p>
            <form onSubmit={enviar} className="space-y-5" data-testid="recuperar-form">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-slate-700">Email</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="username"
                  placeholder="tu@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="recuperar-email"
                />
              </div>
              {error && (
                <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="recuperar-error">
                  {error}
                </div>
              )}
              <Button type="submit" className="w-full" disabled={loading || !email.trim()} data-testid="recuperar-enviar">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Mandarme el link"}
              </Button>
            </form>
            <Link to="/login" className="inline-block mt-8 text-sm text-slate-500 underline">
              Volver al ingreso
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
